import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import type { JobPostsQueryMetadata } from './types';

import { paginatedApiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { jobPostSchema } from './schemas';

export const jobPostsQueryOptions = (metadata: JobPostsQueryMetadata) =>
  queryOptions({
    queryKey: QueryKeys.jobPosts.index.metadata(metadata),
    queryFn: async () => {
      const { pagination } = metadata;

      const response = await fetchJson('/job-posts', {
        schema: paginatedApiResourceSchema(jobPostSchema.array()),
        params: {
          pagination: { pageIndex: pagination.pageIndex + 1, pageSize: pagination.pageSize },
          activityIds: metadata.activityIds,
          regions: metadata.regions,
          locationTypes: metadata.locationType !== null ? [metadata.locationType] : [],
        },
      });

      return response;
    },
    staleTime: 30 * 1000,
    gcTime: 2 * 60 * 1000,
    placeholderData: keepPreviousData,
  });

export const useJobPosts = (metadata: JobPostsQueryMetadata) => {
  return useQuery(jobPostsQueryOptions(metadata));
};
